import { alphabeticalCompare } from '@cims-online/shared'
import type { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { triggerLabel } from '../../../utils/triggerMetadata'
import type { NotificationTemplate } from '../types'

export const useColumns = (): CIMSColumn<NotificationTemplate>[] => [
  {
    title: 'Name',
    render: 'name',
    sort: {
      with: 'callback',
      default: 'ascend',
      onCompare: (a, b) => alphabeticalCompare(a.name, b.name),
    },
    filter: {
      type: 'search',
      with: 'callback',
      onFilter: (value, { name }) =>
        name.toLowerCase().includes(value.toString().toLowerCase()),
    },
    width: 200,
  },
  {
    title: 'Trigger',
    render: ({ trigger }) => triggerLabel(trigger),
    help: 'The event associated with this template.',
    sort: {
      with: 'callback',
      onCompare: (a, b) =>
        alphabeticalCompare(triggerLabel(a.trigger), triggerLabel(b.trigger)),
    },
    filter: {
      type: 'default',
      with: 'items',
      key: 'trigger',
      items: (records) =>
        records
          .map(({ trigger }) => ({
            text: triggerLabel(trigger),
            value: trigger,
          }))
          .sort((a, b) => alphabeticalCompare(a.text, b.text)),
    },
    width: 200,
  },
]
